import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import OrderProductsApi from '~/src/services/api/OrderProductsApi';

interface ParamProps {
  id?: string;
}

export default function OpTest() {
  const { id } = useParams();

  const getItem = async () => {
    // start
    const res = await OrderProductsApi.optest(id);
  };

  useEffect(() => {
    getItem();
  }, []);

  return <div>OpTest2</div>;
}
